/* eslint no-throw-literal: 0 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import storageService from '../../utils/storageService';
import { objDiff } from '../../utils';
// import { redirect403 } from '../../utils/meta';
var DEFAULT_OPTS = {
    noDraft: false,
    noOrgHeader: false,
    appId: '',
};
// const DEFAULT_FETCH_SETTINGS = {
//   is403Handled: false,
// };
var Api = /** @class */ (function () {
    function Api(apiBaseUrl, platformVersion) {
        var _this = this;
        this.IS_DRAFTABLE = true;
        this.handleHeaders = function (action, updatedAt, isJson, options) {
            if (options === void 0) { options = DEFAULT_OPTS; }
            var headers = {};
            var token = _this.getToken();
            var organizationId = _this.getSelectedOrganizationId();
            if (isJson) {
                headers.Accept = 'application/json';
                headers['Content-Type'] = 'application/json';
            }
            if (token && token.length > 0) {
                headers.Authorization = "Bearer ".concat(token);
            }
            if (action === 'GET' || action === 'DELETE') {
                headers['X-APTR-Drafts-Include'] = !options.noDraft;
            }
            if ((action === 'PUT' || action === 'PATCH') && updatedAt) {
                headers['X-APTR-Updated-At'] = updatedAt;
            }
            if (organizationId && !options.noOrgHeader) {
                headers['X-APTR-Organization'] = organizationId;
            }
            if (options.appId) {
                headers['X-APTR-App'] = options.appId;
            }
            if (_this.APT_VERSION) {
                headers['X-APTR-Version'] = _this.APT_VERSION;
            }
            return headers;
        };
        this.getToken = function () { return storageService.getItem('token'); };
        this.getSelectedOrganizationId = function () {
            return storageService.getItem('selectedOrganizationId');
        };
        this.handleURL = function (path) { return "".concat(_this.API_BASE_URL).concat(path); };
        this.handleBody = function (params, isJson) { return (isJson ? JSON.stringify(params) : params); };
        this.handleOptions = function (action, params, headerHandler, bodyHandler, updatedAt, isJson, options) {
            if (params === null) {
                return {
                    headers: headerHandler(action, updatedAt, isJson, options),
                    method: action,
                };
            }
            return {
                headers: headerHandler(action, updatedAt, isJson, options),
                method: action,
                body: bodyHandler(params, isJson),
            };
        };
        this.get = function (route, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'GET',
                        PARAMS: null,
                        updatedAt: false,
                        isJson: true,
                        options: options,
                    })];
            });
        }); };
        this.getFile = function (route) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'GET',
                        PARAMS: null,
                        updatedAt: false,
                    })];
            });
        }); };
        this.postGetFile = function (route, params, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'POST',
                        PARAMS: params,
                        updatedAt: false,
                        isJson: true,
                        options: options,
                        isFileRes: true,
                    })];
            });
        }); };
        this.post = function (route, params, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'POST',
                        PARAMS: params,
                        updatedAt: false,
                        isJson: true,
                        options: options,
                    })];
            });
        }); };
        this.put = function (route, params, isDraftable, options) { return __awaiter(_this, void 0, void 0, function () {
            var latest, paramsDiff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isDraftable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.get(route)];
                    case 1:
                        latest = _a.sent();
                        paramsDiff = objDiff(params, latest);
                        return [2 /*return*/, this.http({
                                PATH: route,
                                ACTION: 'PUT',
                                PARAMS: paramsDiff,
                                updatedAt: latest.updated_at,
                                isJson: true,
                                options: options,
                            })];
                    case 2: return [2 /*return*/, this.http({
                            PATH: route,
                            ACTION: 'PUT',
                            PARAMS: params,
                            updatedAt: false,
                            isJson: true,
                            options: options,
                        })];
                }
            });
        }); };
        this.patch = function (route, params, isDraftable, options) { return __awaiter(_this, void 0, void 0, function () {
            var latest, paramsDiff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isDraftable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.get(route)];
                    case 1:
                        latest = _a.sent();
                        paramsDiff = objDiff(params, latest);
                        return [2 /*return*/, this.http({
                                PATH: route,
                                ACTION: 'PATCH',
                                PARAMS: paramsDiff,
                                updatedAt: latest.updated_at,
                                isJson: true,
                                options: options,
                            })];
                    case 2: return [2 /*return*/, this.http({
                            PATH: route,
                            ACTION: 'PATCH',
                            PARAMS: params,
                            updatedAt: false,
                            isJson: true,
                            options: options,
                        })];
                }
            });
        }); };
        this.patchFormData = function (route, params, isDraftable) { return __awaiter(_this, void 0, void 0, function () {
            var latest, paramsDiff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isDraftable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.get(route)];
                    case 1:
                        latest = _a.sent();
                        paramsDiff = objDiff(params, latest);
                        return [2 /*return*/, this.http({
                                PATH: route,
                                ACTION: 'PATCH',
                                PARAMS: paramsDiff,
                                updatedAt: latest.updated_at,
                                isJson: false,
                            })];
                    case 2: return [2 /*return*/, this.http({
                            PATH: route,
                            ACTION: 'PATCH',
                            PARAMS: params,
                            updatedAt: false,
                            isJson: false,
                        })];
                }
            });
        }); };
        this.postFormData = function (route, params, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'POST',
                        PARAMS: params,
                        updatedAt: false,
                        isJson: false,
                        options: options,
                    })];
            });
        }); };
        this.delete = function (route, params, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http({
                        PATH: route,
                        ACTION: 'DELETE',
                        PARAMS: params,
                        updatedAt: false,
                        isJson: true,
                        options: options,
                    })];
            });
        }); };
        this.create401Error = function (message) { return ({
            message: message,
            logoutRequest: true,
        }); };
        this.injectApi401Callback = function (cb) {
            _this.injectedApi401Callback = cb;
        };
        this.injectApi403Callback = function (cb) {
            _this.injectedApi403Callback = cb;
        };
        this.injectApiGenericCallback = function (cb) {
            _this.injectedApiGenericCallback = cb;
        };
        this.http = function (_a) {
            var PATH = _a.PATH, ACTION = _a.ACTION, PARAMS = _a.PARAMS, updatedAt = _a.updatedAt, isJson = _a.isJson, options = _a.options, isFileRes = _a.isFileRes;
            return __awaiter(_this, void 0, void 0, function () {
                var OPTIONS, URL, response, errorResponseFromEP, errorMessageFromEP, _b, error_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            OPTIONS = this.handleOptions(ACTION, PARAMS, this.handleHeaders, this.handleBody, updatedAt, isJson, options);
                            URL = this.handleURL(PATH);
                            return [4 /*yield*/, fetch(URL, OPTIONS)];
                        case 1:
                            response = _c.sent();
                            if (response.status === 401) {
                                if (PATH.includes('/resetpassword')) {
                                    throw {
                                        status: response.status,
                                        error: new Error('expired token'),
                                    };
                                }
                                if (this.injectedApi401Callback) {
                                    this.injectedApi401Callback();
                                }
                                else {
                                    storageService.removeItem('token');
                                    throw {
                                        status: response.status,
                                        error: new Error('invalid token'),
                                    };
                                }
                            }
                            if (response.status === 409) {
                                if (PATH.includes('/signup/validate')) {
                                    throw {
                                        status: response.status,
                                        error: new Error('Signup link is invalid'),
                                    };
                                }
                            }
                            if (response.status === 403) {
                                if (this.injectedApi403Callback) {
                                    if (PATH.includes('/auth/login')) {
                                        this.injectedApi403Callback('Wrong email or password');
                                    }
                                    else {
                                        this.injectedApi403Callback();
                                    }
                                }
                                else {
                                    throw {
                                        status: response.status,
                                        error: new Error('Insufficient permission'),
                                    };
                                }
                            }
                            if (!(response.status > 399 &&
                                response.status !== 401 &&
                                response.status !== 402) // this is the error code which returns for stripe error along with error object, so it needs to pass
                            ) return [3 /*break*/, 3]; // this is the error code which returns for stripe error along with error object, so it needs to pass
                            return [4 /*yield*/, response.json()];
                        case 2:
                            errorResponseFromEP = _c.sent();
                            errorMessageFromEP = (errorResponseFromEP === null || errorResponseFromEP === void 0 ? void 0 : errorResponseFromEP.error) || '';
                            throw {
                                status: response.status,
                                error: new Error('unknown server error'),
                                errorFromEP: new Error(errorMessageFromEP),
                            };
                        case 3:
                            if (ACTION === 'DELETE') {
                                return [2 /*return*/, false];
                            }
                            _c.label = 4;
                        case 4:
                            _c.trys.push([4, 8, , 9]);
                            if (!(isJson && !isFileRes)) return [3 /*break*/, 6];
                            return [4 /*yield*/, response.json()];
                        case 5:
                            _b = _c.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            _b = response;
                            _c.label = 7;
                        case 7: 
                        // if isJson AND isFileRes then it's a POST endpoint that returns a file,
                        // so return response so caller can await response.blob()
                        return [2 /*return*/, _b];
                        case 8:
                            error_1 = _c.sent();
                            // some endpoints return empty.....
                            return [2 /*return*/, false];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        };
        this.API_BASE_URL = apiBaseUrl;
        this.APT_VERSION = platformVersion;
    }
    return Api;
}());
export default Api;
